var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100%",
    viewBox: "0 0 600 600",
    enableBackground: "new 0 0 600 600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 300,
    cy: 300,
    r: 295,
    stroke: "#e7e7e7",
    fill: "none",
    strokeWidth: "1px"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    opacity: 1,
    stroke: "none",
    d: " M419.338562,171.357422  C384.266937,212.609085 349.400330,253.567825 314.684418,294.653870  C313.068573,296.566254 312.024109,299.614563 312.017273,302.137360  C311.867554,357.283142 311.915771,412.429382 311.892639,467.575562  C311.887390,480.039337 304.898254,488.547607 293.316101,490.389404  C282.709717,492.076050 272.012115,484.627228 270.014069,474.005798  C269.525360,471.407867 269.416046,468.707184 269.414551,466.053619  C269.382385,408.908203 269.435120,351.762695 269.341309,294.617432  C269.327606,286.252167 271.715820,279.282318 277.285706,272.782501  C315.862183,227.765121 354.185394,182.530655 392.602295,137.376434  C400.487732,128.108093 412.861084,126.529648 422.037231,133.561111  C431.232361,140.607147 433.032715,152.911499 426.172760,162.954681  C424.209991,165.828201 421.785553,168.386398 419.338562,171.357422  z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    opacity: 1,
    stroke: "none",
    d: " M226.450256,261.729614  C219.513031,260.449982 214.577255,256.888428 210.406433,251.781952  C183.564774,218.918869 156.626724,186.134506 129.716675,153.327316  C123.604179,145.875305 121.625397,137.700104 125.978081,128.767105  C129.956512,120.602196 137.004364,116.996758 145.838181,117.059380  C152.816666,117.108849 158.022095,120.843636 162.316376,126.101326  C180.632706,148.526962 198.979614,170.927643 217.320908,193.332886  C226.176147,204.150208 235.026978,214.971207 243.911469,225.764465  C249.773804,232.886322 251.925934,240.710632 247.866684,249.356934  C243.742950,258.140564 236.300949,261.771118 226.450256,261.729614  z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    opacity: 1,
    stroke: "none",
    d: " M452.789185,475.317383  C447.967926,490.361725 435.018372,496.556183 422.380005,490.186707  C415.257111,486.596924 411.029816,480.674316 410.988403,472.762451  C410.793243,435.478607 410.751282,398.192200 410.992706,360.908905  C411.064209,349.865265 420.968964,341.007996 431.983795,341.034302  C442.946930,341.060486 452.860657,350.059601 452.909790,361.039276  C453.079468,398.988251 452.899170,436.938843 452.789185,475.317383  z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    opacity: 1,
    stroke: "none",
    d: " M435.742920,275.888062  C438.911163,262.007629 449.300446,253.832886 462.261536,254.658722  C475.565399,255.506409 485.682648,264.987183 486.869141,277.718231  C488.058655,290.481873 479.916504,301.986359 467.292908,305.378754  C449.809479,310.077118 432.817139,294.445557 435.742920,275.888062  z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYi);
export default __webpack_public_path__ + "static/media/Yi.1ac4dfdfee23a0b4e309cd7b38f28741.svg";
export { ForwardRef as ReactComponent };